(function () {
  'use strict';

  /* ---- 4. Focusable content inside aria-hidden (carousel off-screen slide) ---- */
  // function neutraliseHiddenSubtrees() {
  //   document.querySelectorAll('[aria-hidden="true"]').forEach(function (host) {
  //     var cs = getComputedStyle(host);
  //     if (cs.display === 'none' || cs.visibility === 'hidden') return; // already out of a11y tree
  //     if ('inert' in HTMLElement.prototype) { host.inert = true; return; }
  //     host.querySelectorAll('a[href],button,input:not([type="hidden"]),select,textarea,[tabindex]')
  //       .forEach(function (el) {
  //         if (el.getAttribute('tabindex') !== '-1') {
  //           el.dataset.prevTabindex = el.getAttribute('tabindex') || '';
  //           el.setAttribute('tabindex', '-1');
  //         }
  //       });
  //   });
  // }

  /* ---- 5. iframe titles ---- */
  function labelIframes() {
    document.querySelectorAll('iframe:not([title]):not([aria-label])').forEach(function (f, i) {
      var host = '';
      try { host = new URL(f.src, location.origin).hostname; } catch (e) {}
      if (!f.offsetParent) { f.setAttribute('title', 'Hidden utility frame'); f.setAttribute('aria-hidden', 'true'); return; }
      f.setAttribute('title', host ? 'Embedded content from ' + host : 'Embedded content ' + (i + 1));
    });
  }

  /* ---- 6. Required state + device-neutral instructions on the swatch group ---- */
  function fixRequiredGroups() {
    document.querySelectorAll('.tpo_option-required-indicator').forEach(function (star) {
      star.setAttribute('aria-hidden', 'true');
      var wrap = star.closest('.tpo_option-container');
      var group = wrap && wrap.querySelector('[role="group"]');
      if (!group) return;

      group.setAttribute('aria-required', 'true');

      if (!group.querySelector('.a11y-required-hint')) {
        var hint = document.createElement('span');
        hint.className = 'a11y-required-hint sr-only';
        hint.id = 'a11y-req-' + Math.random().toString(36).slice(2, 8);
        hint.textContent = 'Required. Choose exactly 12 bottles. Press Space on a bottle to select or deselect it.';
        group.insertAdjacentElement('afterbegin', hint);
        group.setAttribute('aria-describedby',
          ((group.getAttribute('aria-describedby') || '') + ' ' + hint.id).trim());
      }
      // "Tap ..." -> device-neutral label
      var label = group.getAttribute('aria-label');
      if (label) group.setAttribute('aria-label', label.replace(/^Tap\b/i, 'Choose'));
    });
  }

  /* ---- 7. WCAG 1.3.5 autocomplete ---- */
  function addAutocomplete() {
    var map = {
      'reviewer_name': 'name',
      'reviewer_email': 'email',
      'contact[email]': 'email',
      'contact[first_name]': 'given-name',
      'contact[last_name]': 'family-name',
      'contact[phone]': 'tel'
    };
    Object.keys(map).forEach(function (n) {
      document.querySelectorAll('input[name="' + n + '"]:not([autocomplete])')
        .forEach(function (el) { el.setAttribute('autocomplete', map[n]); });
    });
    document.querySelectorAll('input[type="email"]:not([autocomplete])')
      .forEach(function (el) { el.setAttribute('autocomplete', 'email'); });
  }

  /* ---- 8. Price semantics: label sale vs regular price ---- */
  function labelPrices() {
    document.querySelectorAll('s').forEach(function (s) {
      if (!/[\d]/.test(s.textContent) || s.dataset.a11yDone) return;
      s.dataset.a11yDone = '1';

      var was = document.createElement('span');
      was.className = 'sr-only';
      was.textContent = ' Regular price ';
      s.insertAdjacentElement('beforebegin', was);

      var end = document.createElement('span');
      end.className = 'sr-only';
      end.textContent = ' (on sale) ';
      s.insertAdjacentElement('afterend', end);

      // Current/sale price sits immediately before the compare-at price
      var current = was.previousElementSibling;
      if (current && !current.querySelector('.sr-only')) {
        var now = document.createElement('span');
        now.className = 'sr-only';
        now.textContent = ' Sale price ';
        current.insertAdjacentElement('beforebegin', now);
      }
    });
  }

  /* ---- 10. Heading level skip (h2 -> h6) : expose a correct level ---- */
  function fixHeadingLevels() {
    document.querySelectorAll('.accordion-content h6').forEach(function (h) {
      h.setAttribute('role', 'heading');
      h.setAttribute('aria-level', '3');
    });
  }

  /* ---- 11. Whitespace / bogus ids ---- */
  function sanitiseIds() {
    document.querySelectorAll('[id]').forEach(function (el) {
      var id = el.id;
      if (id === '[object HTMLSelectElement]') { el.removeAttribute('id'); return; }
      if (!/\s/.test(id)) return;
      var safe = id.trim().replace(/\s+/g, '-').replace(/[^\w\-:.]/g, '');
      document.querySelectorAll('label[for], [aria-labelledby], [aria-describedby], [aria-controls]')
        .forEach(function (ref) {
          ['for', 'aria-labelledby', 'aria-describedby', 'aria-controls'].forEach(function (attr) {
            var v = ref.getAttribute(attr);
            if (v && v.split(/\s+/).indexOf(id) > -1) {
              ref.setAttribute(attr, v.split(/\s+/).map(function (t) { return t === id ? safe : t; }).join(' '));
            }
          });
        });
      el.id = safe;
    });
  }

  /* ---- 12. Skip-link target must accept focus ---- */
  function fixSkipTarget() {
    var main = document.getElementById('root');
    if (main && !main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
  }

  /* ---- 13. Promote title-only names to aria-label ---- */
  function promoteTitles() {
    document.querySelectorAll('a[title],button[title],[role="button"][title],[role="tab"][title]')
      .forEach(function (el) {
        if (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby')) return;
        if ((el.textContent || '').trim()) return;
        if (el.querySelector('img[alt]:not([alt=""]), svg title')) return;
        el.setAttribute('aria-label', el.getAttribute('title').trim());
      });
  }

  /* ---- 14. Name the landmarks ---- */
  function labelLandmarks() {
    var asides = document.querySelectorAll('aside:not([aria-label]):not([aria-labelledby])');
    if (asides[0]) asides[0].setAttribute('aria-label', 'Supplementary information');
    if (asides[1]) asides[1].setAttribute('aria-label', 'Sticky add to cart');

    document.querySelectorAll('section:not([aria-label]):not([aria-labelledby])').forEach(function (sec) {
      var h = sec.querySelector('h1,h2,h3');
      if (h) {
        if (!h.id) h.id = 'sec-h-' + Math.random().toString(36).slice(2, 8);
        sec.setAttribute('aria-labelledby', h.id);
      } else {
        sec.setAttribute('role', 'group'); // stop it claiming a nameless region
      }
    });
  }

  /* ---- 15. New-tab notice, noopener, decorative SVGs, vague links ---- */
  function miscFixes() {
    document.querySelectorAll('a[target="_blank"]').forEach(function (a) {
      var rel = (a.getAttribute('rel') || '');
      if (!/noopener/.test(rel)) a.setAttribute('rel', (rel + ' noopener noreferrer').trim());
      if (a.dataset.a11yNewtab) return;
      a.dataset.a11yNewtab = '1';
      var name = (a.getAttribute('aria-label') || a.textContent || '').trim();
      if (a.getAttribute('aria-label')) {
        a.setAttribute('aria-label', name + ' (opens in a new tab)');
      } else if (name) {
        var sr = document.createElement('span');
        sr.className = 'sr-only';
        sr.textContent = ' (opens in a new tab)';
        a.appendChild(sr);
      }
    });

    document.querySelectorAll('svg:not([aria-hidden]):not([aria-label]):not([role])').forEach(function (svg) {
      if (!svg.querySelector('title')) {
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
      }
    });

    // "More" -> descriptive name
    document.querySelectorAll('a').forEach(function (a) {
      if (/^more$/i.test((a.textContent || '').trim()) && !a.getAttribute('aria-label')) {
        var ctx = a.closest('section, li, article');
        var h = ctx && ctx.querySelector('h1,h2,h3,h4');
        a.setAttribute('aria-label', 'More' + (h ? ' about ' + h.textContent.trim() : ' product categories'));
      }
    });
  }

  function runAll() {
    sanitiseIds(); fixSkipTarget(); labelIframes(); fixRequiredGroups();
    addAutocomplete(); labelPrices(); fixHeadingLevels(); promoteTitles();
    labelLandmarks(); miscFixes(); neutraliseHiddenSubtrees();
  }

  if (document.readyState !== 'loading') runAll();
  else document.addEventListener('DOMContentLoaded', runAll);

  // Shopify sections / variant swaps / third-party widgets re-render constantly
  var t;
  new MutationObserver(function () {
    clearTimeout(t); t = setTimeout(runAll, 300);
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', runAll);
})();

